module.exports = __webpack_public_path__ + "img/main-winter_m.215bc412.jpg";